import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../../constants/FieldsConst';
import { textLabels } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import * as ROUTES from '../../../../../router/Routes';
import { LoadingWidget } from '../../../../../widgets';
import ActionsListWidget from '../../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allSuscripcionesAction,
  deleteSuscripcionesAction,
  setActivoSuscripcionesAction,
} from '../SuscripcionesAction';
import { PARAMS_SUSCRIPCIONES } from '../SuscripcionesReducer';

let intervalSearch = null;

const ListadoSuscripciones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const suscripcionesStore = Redux.useSelector((state) => state.suscripciones);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      if (suscripcionesStore.all && suscripcionesStore.all.length === 0) {
        await allSuscripcionesAction(dispatch, suscripcionesStore.params);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      await allSuscripcionesAction(dispatch, suscripcionesStore.params);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suscripcionesStore.params]);

  const _handleEditClick = async (id) => {
    const data = suscripcionesStore.all.find((el) => el.id === id);
    await setActivoSuscripcionesAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteSuscripcionesAction(
      { dispatch, notify },
      suscripcionesStore.activo.id,
      suscripcionesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.entidad.name,
      label: CONST.entidad.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.nombre}
              </NameComponent>
              <Typography variant="body1" color="initial">
                {value.correo}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: CONST.titular.name,
      label: CONST.titular.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
              >
                {value.perfil.pnombre} {value.perfil.papellido}
              </NameComponent>
              <Typography variant="body1" color="initial">
                {value.correo}
              </Typography>
            </>
          );
        },
      },
    },
    {
      name: CONST.fechaInicio.name,
      label: CONST.fechaInicio.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.fechaFinal.name,
      label: CONST.fechaFinal.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value?.nombre ?? '--'}
                size="small"
                color={value?.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const data = suscripcionesStore.all.find(
            (el) => el.id === tableMeta.rowData[0],
          );
          return (
            <Stack direction="row">
              <BotonComponent
                click={async () => {
                  await setActivoSuscripcionesAction(dispatch, data);
                  history.push(ROUTES.pagosSuscripcion.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de gestión"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  await setActivoSuscripcionesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    serverSide: true,
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(() => {
          const payload = {
            ...suscripcionesStore.params,
            q: searchQuery,
          };
          dispatch({ type: PARAMS_SUSCRIPCIONES, payload });
        }, 800);
      }
    },
    onSearchClose: () => {
      const payload = {
        ...suscripcionesStore.params,
        q: null,
      };
      dispatch({ type: PARAMS_SUSCRIPCIONES, payload });
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={suscripcionesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={suscripcionesStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {suscripcionesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="body1">
            <strong>Entidad</strong>: {suscripcionesStore.activo.entidad.nombre}
            <br />
            <strong>Titular</strong>:{' '}
            {suscripcionesStore.activo.titular.perfil.pnombre}{' '}
            {suscripcionesStore.activo.titular.perfil.papellido}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoSuscripciones;
